var map = {
	"./1-SUCCESS.svg": "0f0b",
	"./2-USED.svg": "b181",
	"./3-INVALID.svg": "56b6",
	"./Ylands-PolyBackground-skyblue-02.png": "96c4",
	"./ajax-loader.gif": "0663",
	"./asset_thumb_placeholder.jpg": "8f50",
	"./asset_thumb_placeholder.webp": "164e",
	"./avatars/avatar_1.png": "129e",
	"./avatars/avatar_1.webp": "4035",
	"./avatars/avatar_10.png": "f4f9",
	"./avatars/avatar_10.webp": "8a40",
	"./avatars/avatar_11.jpg": "f140",
	"./avatars/avatar_11.webp": "b583",
	"./avatars/avatar_12.jpg": "f682",
	"./avatars/avatar_13.jpg": "efe9",
	"./avatars/avatar_14.jpg": "3ff9",
	"./avatars/avatar_2.png": "82b9",
	"./avatars/avatar_2.webp": "f103",
	"./avatars/avatar_3.png": "796b",
	"./avatars/avatar_3.webp": "ed78",
	"./avatars/avatar_4.png": "04bb",
	"./avatars/avatar_4.webp": "43d6",
	"./avatars/avatar_5.png": "1caa",
	"./avatars/avatar_5.webp": "939e",
	"./avatars/avatar_6.png": "97b9",
	"./avatars/avatar_6.webp": "1b23",
	"./avatars/avatar_7.png": "f1ae",
	"./avatars/avatar_7.webp": "e525",
	"./avatars/avatar_8.png": "de31",
	"./avatars/avatar_8.webp": "8cf7",
	"./avatars/avatar_9.png": "c6b0",
	"./avatars/avatar_9.webp": "25a4",
	"./coyn.png": "4a7d",
	"./error-404-md.jpg": "8da0",
	"./error-404-xl.jpg": "573d",
	"./error-404-xs.jpg": "733c",
	"./error-404.jpg": "e885",
	"./error-500-lg.jpg": "9aa8",
	"./error-500-sm.jpg": "4aeb",
	"./error-500-xl.jpg": "da71",
	"./error-500.jpg": "386d",
	"./game-characters.png": "a3f8",
	"./game-characters.webp": "0019",
	"./loaders/oval.svg": "9df8",
	"./modal-new.png": "c8c8",
	"./modal-update.png": "da2b",
	"./sprite.svg": "4882"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";